var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.ready && _vm.isActive)?_c('Notifications'):_vm._e(),(_vm.ready && _vm.isActive)?_c('router-view'):_c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"","alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }